import { A } from '@solidjs/router';
import { Component, Show } from 'solid-js';

import logo from '../../assets/logo.png';

const Header: Component = () => {
	return (
		<>
            <div class="navbar bg-base-200 shadow-md">
                <div class="navbar-start">
                    <div class="dropdown">
                        <img src={logo} alt='logo' width='40' height='40' />
                        {/* <span class="ml-5 text-xl linear-gradient text-transparent bg-clip-text bg-gradient-to-r from-[#0771db] to-[#4e4e50]">Ordres Francophone des Développeurs</span> */}
                    </div>
                </div>
                <div class="navbar-end">
                    <label class="swap swap-rotate text-2xl text-base-content/50 hover:text-base-content/100">
                      <input type="checkbox" class="theme-controller" value="orderlight" />
                      <i class="swap-off fa-light fa-moon" />
                      <i class="swap-on fa-light fa-sun" />
                    </label>
                    {/* <Show when={true}>
                      <div class="text-success">Bienvenue, salut</div>
                    </Show> */}
                    <label class="tab" title="Login">
                        <A href="/Login" class="btn btn-soft btn-success text-sm hover:bg-success/50">
                            Se Connecter
                        </A>
                    </label>
                </div>
            </div>
		</>
	);
};

export default Header;
